import { render, staticRenderFns } from "./Hkiarace.vue?vue&type=template&id=b66a1800"
import script from "./Hkiarace.vue?vue&type=script&lang=js"
export * from "./Hkiarace.vue?vue&type=script&lang=js"
import style0 from "./Hkiarace.vue?vue&type=style&index=0&id=b66a1800&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports